/** @prettier */

import {TFunction} from 'i18next';

/**
 * APIエラーアラート
 * @param trans 翻訳関数
 */
export const apiErrorAlert = (trans: TFunction) => {
  return alert(trans('apiErrorAlert.alertMsg.communicationErr'));
};
